import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from 'primeng/panel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PrimeNGConfig } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { BadgeModule } from 'primeng/badge';
import { ChipModule } from 'primeng/chip';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuModule } from 'primeng/menu';
import { ImageModule } from 'primeng/image';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { StepsModule } from 'primeng/steps';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SidebarModule } from 'primeng/sidebar';
import { ScrollerModule } from 'primeng/scroller';
import { DragDropModule } from 'primeng/dragdrop';
import { PickListModule } from 'primeng/picklist';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from "primeng/password";
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TreeModule } from 'primeng/tree';
import { EditorModule } from 'primeng/editor';

const initializeAppFactory = (primeConfig: PrimeNGConfig) => () => {
  // ......
  primeConfig.ripple = true;
};

@NgModule({
  declarations: [],
  providers: [
    ConfirmationService,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [PrimeNGConfig],
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MessagesModule,
    MessageModule,
    PanelMenuModule,
    MenubarModule,
    SplitButtonModule,
    PanelModule,
    CardModule,
    CalendarModule,
    TabViewModule,
    CheckboxModule,
    TableModule,
    DialogModule,
    ConfirmPopupModule,
    ToastModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    PaginatorModule,
    ToggleButtonModule,
    BadgeModule,
    ChipModule,
    SkeletonModule,
    MenuModule,
    ImageModule,
    TriStateCheckboxModule,
    StepsModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    SidebarModule,
    ScrollerModule,
    DragDropModule,
    PickListModule,
    DividerModule,
    PasswordModule,
    MultiSelectModule,
    TagModule,
    SelectButtonModule,
    RadioButtonModule,
    ScrollPanelModule,
    TreeModule,
    EditorModule,
    TooltipModule
  ],
  exports: [
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MessagesModule,
    MessageModule,
    PanelMenuModule,
    MenubarModule,
    SplitButtonModule,
    PanelModule,
    CardModule,
    CalendarModule,
    TabViewModule,
    CheckboxModule,
    TableModule,
    DialogModule,
    ConfirmPopupModule,
    ToastModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    PaginatorModule,
    ToggleButtonModule,
    BadgeModule,
    ChipModule,
    SkeletonModule,
    MenuModule,
    ImageModule,
    TriStateCheckboxModule,
    StepsModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    SidebarModule,
    ScrollerModule,
    DragDropModule,
    PickListModule,
    DividerModule,
    PasswordModule,
    MultiSelectModule,
    TagModule,
    SelectButtonModule,
    RadioButtonModule,
    ScrollPanelModule,
    TreeModule,
    EditorModule,
    TooltipModule
  ],
})
export class PrimengModule {}
